import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, Colors } from 'chart.js';

// Register necessary Chart.js components
ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement);

export default function SparklineChart({ data }) {
  const startDate = new Date();
  const labels = Array(168).fill('').map((_, i) => {
    const hoursAgo = 167 - i;
    const date = new Date(startDate.getTime() - hoursAgo * 60 * 60 * 1000);
    return i % 24 === 0
      ? date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric'
        })
      : '';
  });
  const minPrice = Math.min(...data);
  const maxPrice = Math.max(...data);
  const marginPercentage = 0.03;
  const suggestedMin = minPrice * (1 - marginPercentage);
  const suggestedMax = maxPrice * (1 + marginPercentage);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Price Trend (Over 7 Days)',
        data: data,
        fill: false,
        borderColor: 'rgba(59, 130, 246, 1)',
        tension: 0.1,
        pointRadius: 0.01,
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          pointStyle: 'line',
        }
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: true,
          maxTicksLimit: 7,
        },
        grid: {
          display: false,
        }
      },
      y: {
        beginAtZero: false,
        suggestedMin: suggestedMin,
        suggestedMax: suggestedMax,
      },
    },
  };
  return <Line data={chartData} options={options} />;
}